/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createNumber } from '../../factoriesAny.js';
export var numberDependencies = {
  typedDependencies: typedDependencies,
  createNumber: createNumber
};